module.exports = __webpack_public_path__ + "static/media/asset.0b274283.svg";